import { takeLatest, call, put } from 'redux-saga/effects';
import Api from '../../Api';
import { GET_ADMIN_ACCESS_FAIL, GET_ADMIN_ACCESS_REQUEST, GET_ADMIN_ACCESS_SUCCESS } from '../actions/adminAccess';

export default function* watcher() {
  yield takeLatest(GET_ADMIN_ACCESS_REQUEST, getAdminAccess);
}

function* getAdminAccess() {
  try {
    const { data } = yield call(Api.getAdminAccess);

    yield put({
      type: GET_ADMIN_ACCESS_SUCCESS,
      payload: data.admin_access,
    });
  } catch (error) {
    console.warn(error, 'while getting admin access');

    let errorMessage = 'Unknown error';

    if (error.response) {
      errorMessage = error.response.data.message || 'Unknown server error';
    } else if (error.request) {
      errorMessage = 'No response from the server';
    } else {
      errorMessage = error.message || 'Unknown error';
    }

    yield put({
      type: GET_ADMIN_ACCESS_FAIL,
      payload: errorMessage,
    });
  }
}

